"use strict";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchGraphql = fetchGraphql;
var _axios = require("@ori/axios");
var _fetchErrors = require("@ori/fetch-errors");
var _tsUtils = require("@ori/ts-utils");
var _constants = require("../constants");
var _handleResponse = require("./handleResponse");
var _isEmptyObject = require("./isEmptyObject");
function fetchGraphql(_) {
    return _fetchGraphql.apply(this, arguments);
}
function _fetchGraphql() {
    _fetchGraphql = /**
 * Fetches data from a GraphQL server using axios library.
 *
 * @typeParam Data The expected data type returned from the GraphQL server.
 * @typeParam Variables The type of variables that the GraphQL query takes.
 * @param options Request options object.
 * @returns A promise that resolves to the requested data and any errors, or rejects with an error.
 * @throws Error When unknown error happens
 * @throws {GraphqlError} When unknown graphql error happens
 * @throws {EmptyBodyGraphqlError} When graphql server ends request with empty response
 * @throws {NonOkResponseGraphqlError} When graphql server ends request with anything than 200 HTTP status code
 */ _async_to_generator(function(param) {
        var query, variables, url, headers, _param_timeout, timeout, _param_requestConfig, requestConfig, _param_onError, onError, requestData, response, error_, error, rethrowError;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query, variables = param.variables, url = param.url, headers = param.headers, _param_timeout = param.timeout, timeout = _param_timeout === void 0 ? _constants.DEFAULT_TIMEOUT : _param_timeout, _param_requestConfig = param.requestConfig, requestConfig = _param_requestConfig === void 0 ? {} : _param_requestConfig, _param_onError = param.onError, onError = _param_onError === void 0 ? function(error) {
                        if (process.env.NODE_ENV !== 'production') {
                            // eslint-disable-next-line no-console -- default error handler
                            console.error(error);
                        }
                    } : _param_onError;
                    requestData = _object_spread({
                        query: query
                    }, variables != null && !(0, _isEmptyObject.isEmptyObject)(variables) && {
                        variables: variables
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        _axios.axios.post('/graphql', requestData, _object_spread_props(_object_spread({}, requestConfig), {
                            baseURL: new URL(url).origin,
                            headers: headers,
                            timeout: timeout
                        }))
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        (0, _handleResponse.handleResponse)(response, {
                            onSuccess: function(param) {
                                var _param_data = param.data, data = _param_data.data, errors = _param_data.errors;
                                if ((0, _tsUtils.isNonNullable)(data)) {
                                    //  Avoid omitting the errors field entirely, as TypeScript won’t provide type safety for 'errors' in result checks, which can lead to brittle and less predictable code
                                    return _object_spread_props(_object_spread({}, data), {
                                        errors: Array.isArray(errors) && errors.length > 0 ? errors : []
                                    });
                                }
                                throw new _fetchErrors.EmptyBodyGraphqlError(response);
                            },
                            onError: function() {
                                throw new _fetchErrors.NonOkResponseGraphqlError(response);
                            }
                        })
                    ];
                case 3:
                    error_ = _state.sent();
                    error = error_ instanceof Error ? error_ : new Error(String(error_));
                    rethrowError = error;
                    // We need to parse that error as it would be unreadable in Application Inisights this way
                    // And also would include too much info
                    if (error instanceof _axios.AxiosError) {
                        rethrowError = new _fetchErrors.GraphqlError(error);
                    } else {
                        rethrowError = error;
                    }
                    onError(rethrowError);
                    throw rethrowError;
                case 4:
                    return [
                        2
                    ];
            }
        });
    } //# sourceMappingURL=fetchGraphql.js.map
    );
    return _fetchGraphql.apply(this, arguments);
}
